import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthPayloadService {
  private secretKey = environment.api.payloadSecret;

  generatePayload(): any {
    const randomText = uuidv4();
    const timestamp = Math.floor(Date.now() / 1000);
    const nonce = uuidv4();

    const message = `${randomText}|${timestamp}|${nonce}`;
    const signature = CryptoJS.HmacSHA256(message, this.secretKey).toString(CryptoJS.enc.Hex);

    const payload = {
      challenge: randomText,
      timestamp,
      nonce,
      signature,
      appname : 'GlicRx',
    };
    return payload;
  }
}